export interface ContentAuthor {
    id: string;
    name: string;
    jobTitle: { de: string; en: string };
    /** Path relative to `/assets/` (e.g. `images/robert-litwak250.jpg`). */
    image: string;
    url?: string;
}

export const DEFAULT_ARTICLE_AUTHOR: ContentAuthor = {
    id: 'robert-litwak',
    name: 'Robert Litwak',
    jobTitle: { de: 'Geschäftsführer der plusForta GmbH', en: 'Managing Director of plusForta GmbH' },
    image: 'images/robert-litwak250.jpg',
};
